<template>
  <div class="place-zones">
    <v-expansion-panels>
      <v-expansion-panel
        v-for="(row, rowIndex) in seatRowsList"
        :key="rowIndex"
        :name="rowIndex"
        class="place-zones__collapse-item mb-5"
      >
        <v-expansion-panel-header>
          <v-row>
            <v-col cols="4" class="d-flex align-center">
              {{ row.title }}
            </v-col>
            <v-col cols="4" class="d-flex align-center">Место</v-col>
            <v-col cols="4" class="d-flex justify-end">
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon v-bind="attrs" v-on="on" :disabled="isLoading" :loading="isLoading"
                    ><v-icon>mdi-dots-vertical</v-icon></v-btn
                  >
                </template>
                <v-list>
                  <v-list-item>
                    <v-btn icon @click="$emit('duplicate-seat-row', rowIndex)"
                      ><v-icon>mdi-content-copy</v-icon></v-btn
                    >
                  </v-list-item>
                  <v-list-item>
                    <v-btn
                    :disabled="isLoading || isOnlyEdit"
                    :loading="isLoading"
                      icon
                      color="red"
                      @click="$emit('remove-seat-row', { id: row.id, index: rowIndex })"
                    >
                      <v-icon>mdi-trash-can-outline</v-icon></v-btn
                    >
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-col>
          </v-row>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row
            v-for="(seat, seatIndex) in sortSeats(row.seats)"
            :key="seatIndex"
            class="place-zones__collapse-item-details"
          >
            <v-col cols="2">
              <div>Место {{ seat.number }}</div>
            </v-col>
            <v-col cols="2" offset="8" class="d-flex justify-end">
              <v-btn
              :disabled="isLoading || isOnlyEdit"
              :loading="isLoading"
                icon
                @click="
                  $emit('remove-seat', {
                    id: seat.id,
                    index: seatIndex,
                    seatRowIndex: rowIndex
                  })
                "
              >
                <v-icon color="red">mdi-trash-can-outline</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <div v-if="isCreateRowEnabled" class="place-zones__form">
      <div class="place-zones__form-item is-left">
        <span>Название ряда</span>
        <v-text-field outlined :disabled="isLoading" v-model.trim="rowTitle" />
      </div>
      <div class="place-zones__form-item is-right">
        <span>Места</span>
        <v-text-field outlined :disabled="isLoading || isOnlyEdit" v-model="number" />

        <v-btn :loading="isLoading" :disabled="isLoading" @click="createSeating"
          >Добавить</v-btn
        >
      </div>
    </div>

    <div class="mt-10">
      <v-btn :disabled="isLoading || isOnlyEdit" :loading="isLoading" @click="toggleCreateRowEnabled">
        {{ isCreateRowEnabled ? 'Отменить' : 'Добавить ряд' }}
      </v-btn>
    </div>
  </div>
</template>

<script>
import rangeParser from 'parse-numeric-range'
const seatValidatorErrorMsg = 'разрешен формат типа "4, 8a-9a, 1-10, 44, 199"'
const seatFieldErrorMsg = 'обязательное поле'

export default {
  name: 'PlaceZonesBuilder',
  // components: { ErrorMessage },
  props: {
    seatRowsList: {
      type: Array,
      default: () => []
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    errorMessages: {
      type: Object,
      default: () => ({})
    },
    isOnlyEdit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isCreateRowEnabled: false,
      rowTitle: null,
      number: null,
      seatValidatorErrorMsg: '',
      seatFieldErrorMsg: ''
    }
  },
  watch: {
    rowTitle () {
      this.seatFieldErrorMsg = ''
    },
    number () {
      this.seatFieldErrorMsg = ''
      this.seatValidatorErrorMsg = ''
    }
  },
  methods: {
    sortSeats (seats) {
      const output = [...seats]
      return output.sort((a, b) => a.number - b.number)
    },
    toggleCreateRowEnabled () {
      this.resetInput()
      this.isCreateRowEnabled = !this.isCreateRowEnabled
    },
    resetInput () {
      this.rowTitle = null
      this.number = null
    },
    prepareSeats (range = '') {
      return String(range)
        .split(',')
        .map(s => s.trim())
        .reduce((result, el) => {
          const numericRangeItems = rangeParser(el)
          const itemsToPush = numericRangeItems.length ? numericRangeItems : [el]
          result.push(...itemsToPush)
          return result
        }, [])
        .map(el => String(el))
    },
    seatValidator (v = '') {
      const regx = /^[a-zA-Z0-9-, ]*$/
      if (v === null) {
        return false
      }
      return !!v.match(regx)
    },
    createSeating () {
      const value = String(this.number).trim()
      if (!this.seatValidator(value)) {
        this.seatValidatorErrorMsg = seatValidatorErrorMsg
        return
      }
      if (!this.rowTitle || !value) {
        this.seatFieldErrorMsg = seatFieldErrorMsg
        return
      }
      this.$emit('create-seat-row', {
        rowTitle: this.rowTitle,
        number: this.prepareSeats(value)
      })
      this.resetInput()
    }
  }
}
</script>
